import { createFileRoute } from '@tanstack/react-router'
import { PrivacyPolicyScreen } from '@web/app/features/vinprivacy/screen'

// Definimos la estructura de nuestros parámetros de búsqueda
type VinPrivacyPolicy = {
  id?: string // Lo ponemos opcional por si entran a la URL vacía
}

export const Route = createFileRoute('/vinprivacy')({
  // Validamos los parámetros de búsqueda
  validateSearch: (search: Record<string, unknown>): VinPrivacyPolicy => {
    return {
      id: (search.id as string) || undefined,
    }
  },
  component: PrivacyPolicyScreen,
})
